import { $ } from "@/common/Axios";

export default {
  /**
   * 成绩管理
   */
  studentScore_update: {
    /*
     * 编辑
     * id 列表ID (integer query required)
     * offlineExamScore 考试成绩 (number query )
     * resitExamScore 补考成绩 (number query )
     * totalScore 总成绩 (number query )
     * usualScore 平时成绩 (number query )
     * workScore 作业成绩 (number query )
     * reportTitle 实习报告或毕设题目 (string query )
     * reportTeacher 指导老师 (string query )
     * studyType 学习类型,key=专业学习类型 (string query )
     * studyHours 学时 (string query )
     */
    put: (p, c) => $.put("/api/ems/examination/studentScore/update", p, c),
  },
  studentScore_publish: {
    /*
     * 发布
     * id 列表ID (integer query required)
     * publishStatus 发布状态（已发布未发布） (string query required)
     */
    put: (p, c) => $.put("/api/ems/examination/studentScore/publish", p, c),
  },
  studentScore_batchPublish: {
    /*
     * 批量发布
     * ids 列表ID (array query required)
     * publishStatus 发布状态（已发布未发布） (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentScore/batchPublish", p, c),
  },
  studentScore_batchPublishByCondition: {
    /*
     * 根据学校、学籍年级、学期批量修改发布状态
     * siteId 学校ID (integer query required)
     * rollGrade 学籍年级 (string query required)
     * term 学期 (integer query )
     * publishStatus 发布状态（已发布未发布） (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentScore/batchPublishByCondition", p, c),
  },
  studentScore_auditChecking: {
    /*
     * 处理复查
     * id 复查列表ID (integer query required)
     * result 处理结果 (string query required)
     * offlineExamScore 修改后考试成绩 (number query )
     * resitExamScore 修改后补考成绩 (number query )
     * totalScore 修改后总成绩 (number query )
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentScore/auditChecking", p, c),
  },
  studentScore_applyChecking: {
    /*
     * 申请复查
     * id 列表ID (integer query required)
     * reason 复查原因 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentScore/applyChecking", p, c),
  },
  studentScore_upload: {
    /*
     * 批量上传
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/examination/studentScore/upload", p, c),
  },
  studentScore_searchForClient: {
    /*
     * C端我的期末考试成绩列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/searchForClient", p, c),
  },
  studentScore_schoolStudentScoreExport: {
    /*
     * 导出高校成绩单-班级
     * siteId 学校ID (integer query required)
     * siteName 学校 (string query required)
     * majorId 专业ID (integer query )
     * term 学期 (integer query )
     * rollGrade 学习年级 (string query required)
     * examTime 年月日，（商职、温职显示考试时间、计量显示批卷时间 湖工大显示填报时间） (string query )
     * studyStart 学习开始时间（年月日，学校湖师需要） (string query )
     * studyEnd 学习结束时间（年月日，学校湖师需要） (string query )
     * commitAdmin 登记人（学校温职需要, 学校湖师默认传登录人名字，学校商职显示任课老师） (string query )
     * checkAdmin 复核人（学校温职需要，湖师毕业成绩册显示负责人） (string query )
     * subType 类型：班级成绩单|班级学习成绩单（商职） 班级成绩单|班级成绩册|毕业成绩册(湖师) (string query )
     * termCN 学期:春季学期|秋季学期, 湖工大 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/schoolStudentScoreExport", p, c),
  },
  studentScore_schoolStudentScoreExportCard: {
    /*
     * 导出高校学生成绩卡（湖工大|农林|计量|温职|商职|工商|旅职职业）-个人
     * siteId 学校ID (integer query required)
     * siteName 学校 (string query required)
     * majorId 专业ID (integer query required)
     * rollGrade 学习年级 (string query required)
     * term 学期 (integer query )
     * examTime 年月日（湖工大、旅职显示为制表时间, 工商职业显示为毕业时间， 湖师显示打印时间） (string query )
     * commitAdmin 经办人（学校商职需要） (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/examination/studentScore/schoolStudentScoreExportCard",
        p,
        c
      ),
  },
  studentScore_listStudentScoreForExport: {
    /*
     * 导出成绩档案-杭商院
     * siteId 学校ID (integer query required)
     * majorId 专业ID (integer query )
     * term 学期 (integer query )
     * rollGrade 学习年级 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/examination/studentScore/listStudentScoreForExport",
        p,
        c
      ),
  },
  studentScore_listForService: {
    /*
     * 服务管理-成绩管理列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/listForService", p, c),
  },
  studentScore_listForEdu: {
    /*
     * 考务管理-成绩管理列表
     */
    get: (p, c) => $.get("/api/ems/examination/studentScore/listForEdu", p, c),
  },
  studentScore_listCheckingRecord: {
    /*
     * 成绩复查记录列表
     * id 列表ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/listCheckingRecord", p, c),
  },
  studentScore_getBySchoolRollId: {
    /*
     * 根据合同编号查询成绩管理列表
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/getBySchoolRollId", p, c),
  },
  studentScore_exportForService: {
    /*
     * 服务管理-成绩管理列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/exportForService", p, c),
  },
  studentScore_exportForEdu: {
    /*
     * 考务管理-成绩管理列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/exportForEdu", p, c),
  },
  studentScore_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/downloadMould", p, c),
  },
  studentScore_remove: {
    /*
     * 删除
     * ids 列表IDS (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/studentScore/remove", p, c),
  },

  /**
   * 自考成绩
   */
  selfTaughtScore_update: {
    /*
     * 编辑
     * score  ( query required)
     */
    put: (p, c) => $.put("/api/ems/examination/selfTaughtScore/update", p, c),
  },
  selfTaughtScore_refreshCredits: {
    /*
     * 刷新学分
     */
    put: (p, c) =>
      $.put("/api/ems/examination/selfTaughtScore/refreshCredits", p, c),
  },
  selfTaughtScore_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/examination/selfTaughtScore/upload", p, c),
  },
  selfTaughtScore_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/selfTaughtScore/list", p, c),
  },
  selfTaughtScore_listUnpassedCourse: {
    /*
     * 未通过课程
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/selfTaughtScore/listUnpassedCourse", p, c),
  },
  selfTaughtScore_listScore: {
    /*
     * 根据合同编号查询成绩
     * schoolRollId 合同编号 (integer query required)
     * examBatch 考期 (string query )
     * passStatus 是否已通过:0未通过，1通过 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/selfTaughtScore/listScore", p, c),
  },
  selfTaughtScore_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/selfTaughtScore/export", p, c),
  },
  selfTaughtScore_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ems/examination/selfTaughtScore/downloadMould", p, c),
  },
  selfTaughtScore_remove: {
    /*
     * 删除
     * id 列表ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/selfTaughtScore/remove", p, c),
  },

  /**
   * 线上考试
   */
  online_update: {
    /*
     * 编辑
     * id 行ID (integer query required)
     * startTime 考试开始时间 (string query required)
     * endTime 考试结束时间 (string query required)
     * dingGroupNo 所在钉钉群 (string query required)
     * onlyAnswerFlag 是否只需要提交答卷照片 (string query )
     * handlePaperPhoto 手持答题卷照片 (string query )
     * beforeExamCheckingPhoto 考前身份核验照片 (string query )
     * firstAnswerPhoto 答卷照片1 (string query required)
     * secondAnswerPhoto 答卷照片2 (string query )
     * thirdAnswerPhoto 答卷照片3 (string query )
     */
    put: (p, c) => $.put("/api/ems/examination/online/update", p, c),
  },
  online_clearExam: {
    /*
     * 打回重考
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/online/clearExam", p, c),
  },
  online_batchAssign: {
    /*
     * 批量分配监考老师
     * ids 列表IDs (array query required)
     * invigilatorId 监考老师ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/online/batchAssign", p, c),
  },
  online_answerForClient: {
    /*
     * C端-提交考试大难
     * id 我的考试列表ID (integer query required)
     * handlePaperPhoto 手持答题卷照片 (string query )
     * beforeExamCheckingPhoto 考前身份核验照片 (string query )
     * firstAnswerPhoto 答卷照片1 (string query required)
     * secondAnswerPhoto 答卷照片2 (string query )
     * thirdAnswerPhoto 答卷照片3 (string query )
     */
    put: (p, c) => $.put("/api/ems/examination/online/answerForClient", p, c),
  },
  online_upload: {
    /*
     * 批量导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/examination/online/upload", p, c),
  },
  online_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/online/list", p, c),
  },
  online_listInvigilator: {
    /*
     * 简单监考老师列表
     */
    get: (p, c) => $.get("/api/ems/examination/online/listInvigilator", p, c),
  },
  online_listForClient: {
    /*
     * C端-我的考试列表
     * finishStatus 完成状态（已完成|未完成） (string query required)
     */
    get: (p, c) => $.get("/api/ems/examination/online/listForClient", p, c),
  },
  online_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/online/export", p, c),
  },
  online_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/ems/examination/online/downloadMould", p, c),
  },
  online_detail: {
    /*
     * 详情
     * id 列表ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/online/detail", p, c),
  },
  online_remove: {
    /*
     * 删除
     * id 列表ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/online/remove", p, c),
  },

  /**
   * 线下考试
   */
  offline_check: {
    /*
     * 验证数据
     * id ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/offline/check", p, c),
  },
  offline_uploadArrange: {
    /*
     * 导入考试安排
     * id ID (integer query required)
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/examination/offline/uploadArrange", p, c),
  },
  offline_save: {
    /*
     * 添加编辑
     * id ID (integer query )
     * name 名称 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/offline/save", p, c),
  },
  offline_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/offline/list", p, c),
  },
  offline_listSimple: {
    /*
     * 简易考试列表
     */
    get: (p, c) => $.get("/api/ems/examination/offline/listSimple", p, c),
  },
  offline_listSimpleCampus: {
    /*
     * 简易考区列表
     * examId 考试ID (integer query )
     */
    get: (p, c) => $.get("/api/ems/examination/offline/listSimpleCampus", p, c),
  },
  offline_listExamWayCard: {
    /*
     * 获取门贴
     * examId 考试ID (integer query required)
     * examCampusList 考区 (array query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/listExamWayCard", p, c),
  },
  offline_getPackageCover: {
    /*
     * 获取试卷袋封面数据
     * examId 考试ID (integer query required)
     * examCampusList 考区 (array query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/getPackageCover", p, c),
  },
  offline_exportSignInData: {
    /*
     * 获取签到表数据
     * examId 考试ID (integer query required)
     * examCampusList 考区 (array query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/exportSignInData", p, c),
  },
  offline_exportExamCards: {
    /*
     * 获取准考证、桌贴
     * examId 考试ID (integer query required)
     * examCampusList 考区 (array query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/exportExamCards", p, c),
  },
  offline_remove: {
    /*
     * 删除考试
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/offline/remove", p, c),
  },

  /**
   * 期末考试发布
   */
  examPublish_confirmForTeacher: {
    /*
     * 管理端班主任确认通知
     * ids ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/examPublish/confirmForTeacher", p, c),
  },
  examPublish_confirmForClient: {
    /*
     * C端确认通知
     * ids ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/examPublish/confirmForClient", p, c),
  },
  examPublish_uploadArrange: {
    /*
     * 导入考试安排
     * id ID (integer query required)
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/examination/examPublish/uploadArrange", p, c),
  },
  examPublish_save: {
    /*
     * 添加编辑
     * exam  ( query required)
     */
    post: (p, c) => $.post("/api/ems/examination/examPublish/save", p, c),
  },
  examPublish_saveMaterial: {
    /*
     * 添加复习资料-考试科目列表
     * examId examId (integer query required)
     * teachingProgramIds teachingProgramId (array query required)
     * reviewMaterialsId reviewMaterialsId (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/examination/examPublish/saveMaterial", p, c),
  },
  examPublish_publish: {
    /*
     * 发布
     * id ID (integer query required)
     * publishStatus 发布或未发布 (string query )
     */
    post: (p, c) => $.post("/api/ems/examination/examPublish/publish", p, c),
  },
  examPublish_searchTeachingProgramId: {
    /*
     * 根据科目名称查询teachingProgramId
     * examId examId (integer query required)
     * teachingProgramName 课程名称（导入命名规则，课程名字-层次-后面随意） (string query required)
     * level 层次（导入命名规则，课程名字-层次-后面随意） (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchTeachingProgramId", p, c),
  },
  examPublish_searchByTeacher: {
    /*
     * 管理端-查询通知
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchByTeacher", p, c),
  },
  examPublish_searchByClient: {
    /*
     * C端-查询通知
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchByClient", p, c),
  },
  examPublish_searchByClientTest: {
    /*
     * C端-查询通知-测试用
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchByClientTest", p, c),
  },
  examPublish_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/list", p, c),
  },
  examPublish_listStudent: {
    /*
     * 列表-考试发布数据-考务
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/listStudent", p, c),
  },
  examPublish_listStudentForService: {
    /*
     * 服务管理-线下考试学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/listStudentForService", p, c),
  },
  examPublish_listSimple: {
    /*
     * 简易考试列表
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/listSimple", p, c),
  },
  examPublish_listSimpleCampus: {
    /*
     * 简易考区列表
     * examId 考试ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/listSimpleCampus", p, c),
  },
  examPublish_listCourse: {
    /*
     * 考试科目列表
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/listCourse", p, c),
  },
  examPublish_exportStudent: {
    /*
     * 导出-考试发布数据-考务
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/exportStudent", p, c),
  },
  examPublish_exportStudentForService: {
    /*
     * 服务管理导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/exportStudentForService", p, c),
  },
  examPublish_detailsForClient: {
    /*
     * C端-查询通知详情
     * examName 考试名称 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/detailsForClient", p, c),
  },
  examPublish_detailList: {
    /*
     * 详情-考试发布数据
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/detailList", p, c),
  },
  examPublish_remove: {
    /*
     * 删除考试
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/examPublish/remove", p, c),
  },
  examPublish_removeStudent: {
    /*
     * 删除学生
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/examPublish/removeStudent", p, c),
  },
  examPublish_removeMaterial: {
    /*
     * 删除复习资料-考试科目列表
     * id 考试科目列表返回的ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/examPublish/removeMaterial", p, c),
  },

  /**
   * 作业发布
   */
  work_updateOverAdmin: {
    /*
     * 修改阅卷老师-学历教育-教学教务-作业发布
     * ids IDs (array query required)
     * overAdminId 批阅人 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/updateOverAdmin", p, c),
  },
  work_updateDeadline: {
    /*
     * 批量编辑截止时间-学历教育-教学教务-作业发布
     * ids ID (array query required)
     * deadline 提交截止时间 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/updateDeadline", p, c),
  },
  work_save: {
    /*
     * 添加编辑-学历教育-教学教务-作业发布
     * id id (integer query )
     * title 题目 (string query )
     * modelFileId 附件 (integer query )
     * rollGrade 学籍年级 (string query required)
     * majorIds 专业（多选） (array query )
     * terms 学期（多选） (array query )
     * deadline 提交截止时间 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/save", p, c),
  },
  work_refuse: {
    /*
     * 打回（可重新提交作业）-学历教育-教学教务-作业发布详情
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/refuse", p, c),
  },
  work_publish: {
    /*
     * 发布作业或成绩-学历教育-教学教务-作业发布
     * ids ID (array query required)
     * type 类型：作业或成绩 (string query required)
     * publishStatus 已发布或未发布 (string query )
     */
    post: (p, c) => $.post("/api/ems/examination/work/publish", p, c),
  },
  work_over: {
    /*
     * 批阅-学历教育-教学教务-作业发布详情
     * id ID (integer query required)
     * score 得分 (number query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/over", p, c),
  },
  work_commitForClient: {
    /*
     * C端提交作业
     * id 查询返回的ID (integer query required)
     * answer 答案 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/commitForClient", p, c),
  },
  work_addModelFile: {
    /*
     * 批量上传作业附件-学历教育-教学教务-作业发布
     * siteId siteId (integer query required)
     * level 层次 (string query )
     * teachingProgramName 文件名称（课程名称命名） (string query required)
     * modelFileId modelFileId (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/addModelFile", p, c),
  },
  work_addModelFileById: {
    /*
     * 单个上传作业附件-学历教育-教学教务-作业发布
     * id 作业ID (integer query required)
     * modelFileId modelFileId (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/addModelFileById", p, c),
  },
  work_searchForClient: {
    /*
     * C端登录查询
     */
    get: (p, c) => $.get("/api/ems/examination/work/searchForClient", p, c),
  },
  work_list: {
    /*
     * 列表-学历教育-教学教务-作业发布
     */
    get: (p, c) => $.get("/api/ems/examination/work/list", p, c),
  },
  work_listStudent: {
    /*
     * 列表-学历教育-教学教务-作业发布详情
     */
    get: (p, c) => $.get("/api/ems/examination/work/listStudent", p, c),
  },
  work_listStudentForService: {
    /*
     * 列表-学历教育-教学教务-作业发布详情
     */
    get: (p, c) =>
      $.get("/api/ems/examination/work/listStudentForService", p, c),
  },
  work_getDetail: {
    /*
     * 交卷详情(阅卷也可调用)-学历教育-教学教务-作业发布详情
     * workId workId (integer query required)
     * schoolRollId schoolRollId (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/work/getDetail", p, c),
  },
  work_export: {
    /*
     * 导出-学历教育-教学教务-作业发布
     */
    get: (p, c) => $.get("/api/ems/examination/work/export", p, c),
  },
  work_exportStudent: {
    /*
     * 导出-学历教育-教学教务-作业发布详情
     */
    get: (p, c) => $.get("/api/ems/examination/work/exportStudent", p, c),
  },
  work_exportStudentForService: {
    /*
     * 导出-学历教育-教学教务-作业发布详情
     */
    get: (p, c) =>
      $.get("/api/ems/examination/work/exportStudentForService", p, c),
  },
  work_remove: {
    /*
     * 批量删除-学历教育-教学教务-作业发布
     * ids IDs (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/work/remove", p, c),
  },
  work_removeStudent: {
    /*
     * 删除单个学生-学历教育-教学教务-作业发布详情
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/work/removeStudent", p, c),
  },

  /**
   * 成绩排名
   */
  score_rank_test: {
    /*
     * 测试定时任务
     */
    post: (p, c) => $.post("/api/ems/examination/score/rank/test", p, c),
  },
  score_rank_listForService: {
    /*
     * 服务管理-成绩排名列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/score/rank/listForService", p, c),
  },
  score_rank_listForEdu: {
    /*
     * 考务管理-成绩排名列表
     */
    get: (p, c) => $.get("/api/ems/examination/score/rank/listForEdu", p, c),
  },
  score_rank_exportForService: {
    /*
     * 服务管理-排名列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/score/rank/exportForService", p, c),
  },
  score_rank_exportForEdu: {
    /*
     * 考务管理-排名列表导出
     */
    get: (p, c) => $.get("/api/ems/examination/score/rank/exportForEdu", p, c),
  },

  /**
   * 线下考试学生
   */
  offlineStudent_list: {
    /*
     * 考务管理-列表
     */
    get: (p, c) => $.get("/api/ems/examination/offlineStudent/list", p, c),
  },
  offlineStudent_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/offlineStudent/export", p, c),
  },
  offlineStudent_remove: {
    /*
     * 删除学生-考务管理
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/offlineStudent/remove", p, c),
  },
};
